export class ResponseFaseAnualModel{
    payload:FaseAnualModel;

    constructor(){
        this.payload = new FaseAnualModel();
    }
}

export class FaseAnualModel{    
    idJardin:number;
    idJardinPeriodo:number;
    idTipoJardin:number;
    idFaseAnual:number;
    estadoFaseAnual:number;
    anios:YearsModel[];
    rbd:string;
    tipoJardin:string;
    jardin:string;
    constructor(){
        this.idJardin = -1;
        this.idJardinPeriodo = -1;
        this.idTipoJardin = -1;
        this.idFaseAnual = -1;
        this.estadoFaseAnual = -1;
        this.anios = new Array<YearsModel>();
        this.rbd = "";
        this.tipoJardin = "";
        this.jardin = "";
    }
}

export class YearsModel{    

    anio:number;
    idFaseAnualAnio:number; 
    orden:number; 
    estadoAnio:number;
    estadoSeguimientoAnio:number;
    areas:AreasAnualesModel[];
    constructor(){
        this.anio = 0;
        this.idFaseAnualAnio = -1;
        this.areas = new Array<AreasAnualesModel>();
        this.orden = -1;
        this.estadoAnio = -1;
        this.estadoSeguimientoAnio = -1;
    }
}

export class AreasAnualesModel{    

    area:string;
    idArea:number; 
    orden:number;
    subdimensiones:SubdimensionModel[];
    constructor(){
        this.area = "";
        this.idArea = -1;
        this.orden = -1;
        this.subdimensiones = new Array<SubdimensionModel>();
    }
}

export class SubdimensionModel{    

    idSubdimension:number;
    subdimension:string;
    numSubdimension:number;
    estrategias:EstrategiasAreasModel[];
    constructor(){
        this.subdimension = "";
        this.idSubdimension = -1;
        this.numSubdimension = -1;
        this.estrategias = new Array<EstrategiasAreasModel>();
    }
}

export class EstrategiasAreasModel{    

    estrategia:string;
    idEstrategia:number;
    orden:number;
    acciones:AccionAnualModel[];
    constructor(){
        this.estrategia = "";
        this.idEstrategia = -1;
        this.orden = -1;
        this.acciones = new Array<AccionAnualModel>();
    }
}

export class AccionAnualModel {    

    idAccion:number;
    idFaseAnual:number;
    accion:string; 
    fechaInicioMedicion:Date;
    fechaFinMedicion:Date;
    medioVerificacion:string;
    seguimiento:string;

    constructor(){
        this.idAccion = -1;
        this.idFaseAnual = -1;
        this.accion = "";
        this.fechaInicioMedicion = null;
        this.fechaFinMedicion = null;
        this.medioVerificacion = "";
        this.seguimiento = "";
    }
}
